import React, { useEffect, useState } from "react";
import { logo, sidePanel1 } from "../assets";
import { ToastContainer, toast } from "react-toastify";
import { validateEmail, validatePassword, setupValue } from "../commons";
import { Input, CheckBox } from "../components";
import { useNavigate, useParams } from "react-router-dom";
import { urlApi } from "../constants";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [visible, setVisible] = useState(false);
  const [veriVisible, setVeriVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  const [pass, setPass] = useState("");
  const [veriPass, setVeriPass] = useState("");
  const [upperValidation, setUpperValidation] = useState(false);
  const [lowerValidation, setLowerValidation] = useState(false);
  const [eightCharValidation, setEightCharValidation] = useState(false);
  const [numberSymValidation, setNumberSymValidation] = useState(false);

  useEffect(() => {
    fetch(urlApi + "/v1/users/password/reset/" + token, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message == "SUCCESS") {
          setLoading(false);
        } else {
          setSent(true);
        }
      })
      .catch((error) => {
        setSent(true);
        setLoading(false);
      });
  }, []);

  const handleOnClick = (event) => {
    event.preventDefault();
    setLoading(true);
    fetch(urlApi + "/v1/users/password/reset/" + token, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
      },
      body: JSON.stringify({
        new_password: pass,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message == "SUCCESS") {
          toast.success("Your password already reset! Please login!", {
            position: "top-center",
            autoClose: 3000,
          });
          setPass("");
          setVeriPass("");
          setUpperValidation(false);
          setLowerValidation(false);
          setEightCharValidation(false);
          setNumberSymValidation(false);
          setLoading(false);
          setTimeout(() => {
            navigate("/");
          }, 3000);
        } else {
          toast.error(data.errors[0], {
            position: "top-center",
            autoClose: 3000,
          });
          setLoading(false);
        }
      })
      .catch((error) => {
        toast.error(error, {
          position: "top-center",
          autoClose: 3000,
        });
        setLoading(false);
      });
  };
  const passOnChange = (e) => {
    setupValue(e, setPass, () => null);
    validatePassword(
      e.target.value,
      setUpperValidation,
      setLowerValidation,
      setEightCharValidation,
      setNumberSymValidation
    );
  };
  const veriPassOnChange = (e) => {
    setupValue(e, setVeriPass, () => null);
  };
  return (
    <div className="flex flex-col bg-white w-full h-screen overflow-hidden justify-center ">
      <ToastContainer />
      <div className="flex flex-row w-full">
        <div className="flex flex-col bg-white justify-center items-center w-full md:w-2/3">
          <img
            src={logo}
            className="w-[130px] md:w-[20%] md:max-w-[130px] mb-8"
          />
          <div className="mb-2 font-semibold text-[28px]">Reset Password</div>
          <div className="mb-10 font-normal text-gray-600 text-center">
            This link for reset password for account
          </div>

          {sent ? (
            <div>
              Link is broken or already expired.{" "}
              <a href="/" className="underline ">
                Back to home.
              </a>
            </div>
          ) : (
            <div className="flex flex-col border text-black justify-center items-center shadow-lg rounded-lg font-rubik w-[70%] sm:max-w-[400px]">
              <div className="flex flex-col w-[90%] py-3">
                <div className="divide-y">
                  <form className="flex flex-col justify-center gap-5">
                    <div className="flex flex-col">
                      <Input
                        id={"password"}
                        error={true}
                        type={visible ? "text" : "password"}
                        req={true}
                        value={pass}
                        onChangefunc={(e) => passOnChange(e)}
                        showIcon={true}
                        stateIcon={visible}
                        setStateIcon={setVisible}
                      />
                    </div>
                    <div className="flex flex-col">
                      <Input
                        id={"Verify password"}
                        error={true}
                        type={veriVisible ? "text" : "password"}
                        req={true}
                        value={veriPass}
                        onChangefunc={(e) => veriPassOnChange(e)}
                        showIcon={true}
                        stateIcon={veriVisible}
                        setStateIcon={setVeriVisible}
                      />
                    </div>
                    <div className="flex flex-row">
                      <div className="flex flex-col">
                        <div className="flex flex-row items-center">
                          <CheckBox
                            className={`${
                              upperValidation
                                ? "fill-primary "
                                : "fill-[#667085] opacity-30"
                            } w-3 h-3 `}
                          />
                          <p className="ml-1 text-[10px] md:text-[12px] font-thin text-gray-500">
                            Uppercase
                          </p>
                        </div>
                        <div className="flex flex-row items-center">
                          <CheckBox
                            className={`${
                              lowerValidation
                                ? "fill-primary "
                                : "fill-[#667085] opacity-30"
                            } w-3 h-3`}
                          />
                          <p className="ml-1 text-[10px] md:text-[12px] font-thin text-gray-500">
                            Lowercase
                          </p>
                        </div>
                        <div className="flex flex-row items-center">
                          <CheckBox
                            className={`${
                              (pass === veriPass) & (pass != "")
                                ? "fill-primary "
                                : "fill-[#667085] opacity-30"
                            } w-3 h-3`}
                          />
                          <p className="ml-1 text-[10px] md:text-[12px] font-thin text-gray-500">
                            Password match
                          </p>
                        </div>
                      </div>
                      <div className="flex flex-col ml-2 md:ml-4">
                        <div className="flex flex-row items-center">
                          <CheckBox
                            className={`${
                              eightCharValidation
                                ? "fill-primary "
                                : "fill-[#667085] opacity-30"
                            } w-3 h-3`}
                          />
                          <p className="ml-1 text-[10px] md:text-[12px] font-thin text-gray-500">
                            Minimum 8 characters
                          </p>
                        </div>
                        <div className="flex flex-row items-center">
                          <CheckBox
                            className={`${
                              numberSymValidation
                                ? "fill-primary "
                                : "fill-[#667085] opacity-30"
                            } w-3 h-3`}
                          />
                          <p className="ml-1 text-[10px] md:text-[12px] font-thin text-gray-500">
                            Number & symbol (_!*#)
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-row">
                      <button
                        type="submit"
                        className={`text-white py-2 px-2 ${
                          !Boolean(
                            (veriPass === pass) &
                              upperValidation &
                              lowerValidation &
                              eightCharValidation &
                              numberSymValidation
                          ) | loading
                            ? "bg-[#667085] bg-opacity-20"
                            : "bg-primary hover:bg-tertiary"
                        } rounded-md w-full flex flex-col items-center justify-center`}
                        disabled={
                          !Boolean(
                            (veriPass === pass) &
                              upperValidation &
                              lowerValidation &
                              eightCharValidation &
                              numberSymValidation
                          ) | loading
                        }
                        onClick={handleOnClick}
                      >
                        {loading ? (
                          <div role="status">
                            <svg
                              aria-hidden="true"
                              className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-secondary"
                              viewBox="0 0 100 101"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                                fill="white"
                              />
                              <path
                                d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                                fill="#E47410"
                              />
                            </svg>
                            <span className="sr-only">Loading...</span>
                          </div>
                        ) : (
                          <p className="font-base tracking-wider text-[14px] md:text-[16px]">
                            Reset Password
                          </p>
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="hidden md:flex flex-col md:w-1/3">
          <img src={sidePanel1} alt="" className="h-full" />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
